__turbopack_context__.v({
  "card": "ProductUpdatesLoadingSkeleton-module-scss-module__8EwOpq__card",
  "heading": "ProductUpdatesLoadingSkeleton-module-scss-module__8EwOpq__heading",
  "label": "ProductUpdatesLoadingSkeleton-module-scss-module__8EwOpq__label",
  "section": "ProductUpdatesLoadingSkeleton-module-scss-module__8EwOpq__section",
  "shimmer": "ProductUpdatesLoadingSkeleton-module-scss-module__8EwOpq__shimmer",
});
